import Vue from "vue";
import VueI18n from "vue-i18n";
import { expandDictionary } from "@/common/functions";
import messages from "./translations/en";

Vue.use(VueI18n);

const i18n = new VueI18n({
	locale: "en",
	messages: {
		en: expandDictionary(messages),
	},
	silentTranslationWarn: true,
});

export default i18n;
